import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction';
import {
  Table, TableBody, TextField, TableCell, TableContainer, TableHead, TableRow, Paper, Button,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide,
  FormControl, InputLabel, Select, MenuItem, Switch, Typography,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Tooltip from '@material-ui/core/Tooltip';
import HttpService from '../../../services/httpService';

const useStyles = makeStyles((theme) => ({
  table: { minWidth: 750 },
  addButton: { backgroundColor: '#FFF2EB', color: '#14419c', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#F47E46", color: '#FFF2EB' } },
  editButton: { backgroundColor: '#FFF2EB', color: '#3d444f', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#3d444f", color: '#FFF2EB' } },
  deleteButton: { backgroundColor: '#FFF2EB', color: '#9c261e', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#9c261e", color: '#FFF2EB' } },
  yesButton: { backgroundColor: '#FFF2EB', color: '#14419c', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: '#FFF2EB' } },
  noButton: { backgroundColor: '#FFF2EB', color: '#151921', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#151921", color: '#FFF2EB' } },
}));

const StyledTableCell = withStyles((theme) => ({
  head: { backgroundColor: "#ccc", color: theme.palette.common.black },
  body: { fontSize: 14 },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: { '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } },
}))(TableRow);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ManageMiscPaymentServiceCaps = (props) => {
  const classes = useStyles();

  const [caps, setCaps] = useState([]);
  const [experienceCenters, setExperienceCenters] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [ecFilter, setEcFilter] = useState("all");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formEc, setFormEc] = useState("");
  const [formServiceType, setFormServiceType] = useState("");
  const [formMaxAmount, setFormMaxAmount] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const fetchCaps = async (ecId) => {
    props.setLoading(true);
    try {
      const res = await HttpService.getServiceTypeCaps(ecId && ecId !== "all" ? ecId : undefined);
      setCaps(res?.data?.data || []);
    } catch (err) {
      props.setSnackInfo("Failed to fetch caps", "error");
    } finally {
      props.setLoading(false);
    }
  };

  const fetchExperienceCenters = async () => {
    try {
      const res = await HttpService.getAllExperienceCenter();
      setExperienceCenters(res?.data?.data || []);
    } catch (err) {
      props.setSnackInfo("Failed to fetch Experience Centres", "error");
    }
  };

  const fetchServiceTypes = async () => {
    try {
      const res = await HttpService.getServiceTypeConfigs();
      setServiceTypes(res?.data?.data || []);
    } catch (err) {
      props.setSnackInfo("Failed to fetch Service Types", "error");
    }
  };

  useEffect(() => {
    fetchExperienceCenters();
    fetchServiceTypes();
    fetchCaps();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchCaps(ecFilter);
    // eslint-disable-next-line
  }, [ecFilter]);

  const handleDialogClose = () => {
    setShowModal(false);
    setIsEdit(false);
    setEditId(null);
    setFormEc("");
    setFormServiceType("");
    setFormMaxAmount("");
  };

  const handleAdd = async () => {
    if (!formEc || !formServiceType || !formMaxAmount) {
      props.setSnackInfo("Experience Centre, Service Type and Max Amount are all required", "error");
      return;
    }
    props.setLoading(true);
    try {
      const res = await HttpService.addServiceTypeCap({
        experienceCenterId: formEc,
        service_type: formServiceType,
        max_amount: formMaxAmount,
      });
      props.setSnackInfo(res?.data?.message || "Cap created", "success");
      handleDialogClose();
      fetchCaps(ecFilter);
    } catch (err) {
      props.setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      props.setLoading(false);
    }
  };

  const handleUpdate = async () => {
    props.setLoading(true);
    try {
      const res = await HttpService.updateServiceTypeCap({ id: editId, max_amount: formMaxAmount });
      props.setSnackInfo(res?.data?.message || "Cap updated", "success");
      handleDialogClose();
      fetchCaps(ecFilter);
    } catch (err) {
      props.setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      props.setLoading(false);
    }
  };

  const handleToggleActive = async (cap) => {
    props.setLoading(true);
    try {
      await HttpService.updateServiceTypeCap({ id: cap._id, isActive: !cap.isActive });
      fetchCaps(ecFilter);
    } catch (err) {
      props.setSnackInfo("Failed to update status", "error");
    } finally {
      props.setLoading(false);
    }
  };

  const openEdit = (cap) => {
    setEditId(cap._id);
    setFormEc(cap.experienceCenterId?._id || cap.experienceCenterId);
    setFormServiceType(cap.service_type);
    setFormMaxAmount(cap.max_amount);
    setIsEdit(true);
    setShowModal(true);
  };

  const closeDeleteModal = () => { setShowDeleteModal(false); setDeleteId(""); };

  const handleDelete = async () => {
    props.setLoading(true);
    try {
      await HttpService.deleteServiceTypeCap(deleteId);
      closeDeleteModal();
      fetchCaps(ecFilter);
      props.setSnackInfo("Cap deleted", "success");
    } catch (err) {
      props.setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      props.setLoading(false);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <div style={{ marginBottom: 10, fontSize: 26, textAlign: 'center' }}><b>Service Type Payment Caps</b></div>
      <Typography variant="caption" color="textSecondary" style={{ display: 'block', textAlign: 'center', marginBottom: 10 }}>
        Max amount payable per Experience Centre + Service Type — shared across every provider offering that service there.
      </Typography>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <FormControl variant="outlined" size="small" style={{ minWidth: 220 }}>
          <InputLabel>Filter by Experience Centre</InputLabel>
          <Select value={ecFilter} onChange={(e) => setEcFilter(e.target.value)} label="Filter by Experience Centre">
            <MenuItem value="all">All Centres</MenuItem>
            {experienceCenters.map((ec) => (
              <MenuItem key={ec._id} value={ec._id}>{ec.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button className={classes.addButton} onClick={() => { setShowModal(true); setIsEdit(false); }} variant="contained">
          Add Cap
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell style={{ textAlign: 'center' }}>Sl No</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Experience Centre</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Service Type</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Max Amount</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Active</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {caps.map((cap, i) => (
              <StyledTableRow key={cap._id}>
                <StyledTableCell style={{ textAlign: 'center' }}>{i + 1}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{cap.experienceCenterId?.name || '—'}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{cap.service_type}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>₹{Number(cap.max_amount).toLocaleString()}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>
                  <Switch checked={!!cap.isActive} onChange={() => handleToggleActive(cap)} size="small" color="primary" />
                </StyledTableCell>
                <StyledTableCell style={{ cursor: 'pointer' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                    <Tooltip title="Edit" placement="top">
                      <Button className={classes.editButton} variant="contained" size="small" onClick={() => openEdit(cap)}>
                        <EditOutlined />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Delete" placement="top">
                      <Button className={classes.deleteButton} variant="contained" size="small" onClick={() => { setShowDeleteModal(true); setDeleteId(cap._id); }}>
                        <DeleteOutlined />
                      </Button>
                    </Tooltip>
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            ))}
            {caps.length === 0 && (
              <TableRow>
                <StyledTableCell colSpan={6} style={{ textAlign: 'center', padding: 24 }}>
                  No caps configured yet.
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={showModal} TransitionComponent={Transition} fullWidth maxWidth="xs" onClose={handleDialogClose}>
        <DialogTitle>{isEdit ? 'Update' : 'Add'} Cap</DialogTitle>
        <DialogContent>
          <DialogContentText />
          <FormControl fullWidth variant="outlined" style={{ marginBottom: 16 }} disabled={isEdit}>
            <InputLabel>Experience Centre</InputLabel>
            <Select value={formEc} onChange={(e) => setFormEc(e.target.value)} label="Experience Centre">
              {experienceCenters.map((ec) => (
                <MenuItem key={ec._id} value={ec._id}>{ec.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined" style={{ marginBottom: 16 }} disabled={isEdit}>
            <InputLabel>Service Type</InputLabel>
            <Select value={formServiceType} onChange={(e) => setFormServiceType(e.target.value)} label="Service Type">
              {serviceTypes.map((s) => (
                <MenuItem key={s._id} value={s.name}>{s.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Max Amount"
            type="number"
            value={formMaxAmount}
            fullWidth
            onChange={(e) => setFormMaxAmount(e.target.value)}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button className={classes.noButton} variant="outlined" onClick={handleDialogClose}>Cancel</Button>
          <Button className={classes.yesButton} variant="outlined" onClick={isEdit ? handleUpdate : handleAdd}>
            {isEdit ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showDeleteModal} TransitionComponent={Transition} fullWidth maxWidth="xs" onClose={closeDeleteModal}>
        <DialogTitle>Delete Cap</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this cap?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className={classes.noButton} variant="outlined" onClick={closeDeleteModal}>Cancel</Button>
          <Button className={classes.deleteButton} variant="outlined" onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(ManageMiscPaymentServiceCaps);
